/**
 * Close mobile/vertical drawer state when crossing to PC viewport.
 * PC CSS is applied via <link media="(min-width: …)"> — no JS injection needed.
 */
(function () {
  var mq;
  try {
    mq = window.matchMedia('(min-width: 750px)');
  } catch (e) {
    return;
  }

  function resetPcNavChrome() {
    if (!mq.matches) return;
    document.querySelectorAll('.navigation-mobile.mobile-menu, .mobile-menu').forEach(function (el) {
      el.classList.remove('nav-open');
    });
    document.querySelectorAll('.mobile-screen, .vertical-screen').forEach(function (el) {
      el.classList.remove('nav-open', 'vertical-open');
    });
    document.querySelectorAll('.vertical-wrapper').forEach(function (el) {
      el.classList.remove('vertical-open');
    });
    document.querySelectorAll('.widget-verticalmenu').forEach(function (el) {
      el.classList.remove('is-categories-open');
    });
    document.querySelectorAll('.vertical-item').forEach(function (el) {
      el.classList.remove('is-submenu-open');
    });
    document.documentElement.classList.remove('no-scroll');
    document.body.classList.remove('no-scroll');
  }

  function onMobileEnter() {
    if (typeof portalSsMobileNavToBody === 'function') portalSsMobileNavToBody();
    if (typeof scheduleMobileDrawerOffsetTop === 'function') scheduleMobileDrawerOffsetTop();
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', function (e) {
      if (e.matches) resetPcNavChrome();
      else onMobileEnter();
    });
  }
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(resetPcNavChrome, 120);
  });
  window.addEventListener('pageshow', resetPcNavChrome);
})();
